import React from "react";
import Chatedaccount from "../dsaimages/ChartedAccount.png";
import Exnaker from "../dsaimages/Exbanker.png";
import FinacalAnalysts from "../dsaimages/Financialanalyst.png";
import Loanagent from "../dsaimages/Loanagent.png";
import mutalfunds from "../dsaimages/mutualfunds.png";
import { Helmet } from "react-helmet-async";

const HomeLoan = () => {
  const WriteDiv = () => (
    <svg
      width="30"
      height="30"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="50"
        cy="50"
        r="45"
        stroke="orange"
        strokeWidth="5"
        fill="none"
      />
      <path
        d="M30 50 L45 65 L75 35"
        stroke="orange"
        strokeWidth="10"
        fill="none"
      />
    </svg>
  );
  return (
    <div className=" min-h-screen py-10  ">
       <Helmet>
              <title>Kota HOLDINGS</title>
              <meta name="description" content="A Vision of My 30-Year World" />
            </Helmet>
      <div className="mx-auto bg-white p-8 rounded-xl ">
        <h1 className="text-2xl font-bold text-left text-[#FF6F00] mb-4">
          We are India’s Leading Home Loan DSA Agent
        </h1>
        <p className="text-left text-gray-600 mb-6">
          Earning Opportunity for all existing agents with Kota Holdings Loan
          Partner Program
        </p>

        <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <input
            type="text"
            placeholder="First Name"
            className="p-3 border rounded-lg w-full"
          />
          <input
            type="text"
            placeholder="Middle Name"
            className="p-3 border rounded-lg w-full"
          />
          <input
            type="text"
            placeholder="Last Name"
            className="p-3 border rounded-lg w-full"
          />
          <input
            type="text"
            placeholder="Mobile Number"
            className="p-3 border rounded-lg w-full"
          />
          <input
            type="text"
            placeholder="Pan Number"
            className="p-3 border rounded-lg w-full"
          />
          <input
            type="email"
            placeholder="Email"
            className="p-3 border rounded-lg w-full"
          />
          <select className="p-3 border rounded-lg w-full">
            <option>Select Profession</option>
          </select>
          <select className="p-3 border rounded-lg w-full">
            <option>Select State</option>
          </select>
          <select className="p-3 border rounded-lg w-full col-span-2">
            <option>Select City</option>
          </select>
          <div className="col-span-2 flex items-center">
            <input type="checkbox" className="mr-2" />
            <span>
              I agree to the{" "}
              <a href="#" className="text-blue-500">
                terms & conditions
              </a>{" "}
              and{" "}
              <a href="#" className="text-blue-500">
                privacy policy
              </a>
              .
            </span>
          </div>
          <button className="col-span-2 bg-[#FF6F00] text-white py-3 rounded-lg text-lg font-semibold hover:bg-[#993D0D]">
            SUBMIT
          </button>
        </form>

        <div className="mt-10">
          <h2 className="text-xl font-bold text-[#FF6F00]">
            What is a Personal Loan DSA?
          </h2>
          <p className="text-gray-600 mt-2">
            A Home Loan Direct Selling Agent (DSA) is a person or company
            authorized by financial institutions to help borrowers navigate the
            application process...
          </p>
        </div>

        <div className="mt-6">
          <h2 className="text-xl font-bold text-[#FF6F00]">
            Who can Become a Personal Loan DSA with Ruloans?
          </h2>
          <div className="mt-6">
            <h2 className="text-xl font-bold text-[#FF6F00] text-center">
              Who can Become a Personal Loan DSA with Ruloans?
            </h2>
            <div className="flex flex-wrap justify-around items-center mt-4 gap-4">
              <div className="text-center">
                <img
                  src={Loanagent}
                  alt="Loan Agent"
                  className="md:h-20 md:w-20 h-14 w-14 mx-auto"
                />
                <span className="block mt-2">Loan Agent</span>
              </div>
              <div className="text-center">
                <img
                  src={Exnaker}
                  alt="Ex-Banker"
                  className="md:h-20 md:w-20 h-14 w-14 mx-auto"
                />
                <span className="block mt-2">Ex-Banker</span>
              </div>
              <div className="text-center">
                <img
                  src={FinacalAnalysts}
                  alt="Financial Analyst"
                  className="md:h-20 md:w-20 h-14 w-14 mx-auto"
                />
                <span className="block mt-2">Financial Analyst</span>
              </div>
              <div className="text-center">
                <img
                  src={mutalfunds}
                  alt="Mutual Fund Agent"
                  className="md:h-20 md:w-20 h-14 w-14 mx-auto"
                />
                <span className="block mt-2">Mutual Fund Agent</span>
              </div>
              <div className="text-center">
                <img
                  src={Chatedaccount}
                  alt="Chartered Accountant"
                  className="md:h-20 md:w-20 h-14 w-14 mx-auto"
                />
                <span className="block mt-2">Chartered Accountant</span>
              </div>
            </div>
          </div>
        </div>
        <h2 className="text-2xl font-bold text-[#FF6F00] mt-10">
          What Are The Eligibility Criteria For The Kota Holdings Home Loan DSA
          Registration Process?
        </h2>
        <p className="mt-4 text-gray-700">
          Kota Holdings Distribution Services Private Limited (RDSPL), a
          registered DSA, has partnerships with more than 275 leading Banks and
          NBFCs to offer loans in more than 4000 cities in India. Kota Holdings
          retail portfolio includes{" "}
          <a href="#" className="text-blue-500 hover:underline">
            Personal Loans
          </a>
          ,{" "}
          <a href="#" className="text-blue-500 hover:underline">
            Business Loans
          </a>
          ,{" "}
          <a href="#" className="text-blue-500 hover:underline">
            Home Loans
          </a>
          , and more.
        </p>

        <div className="mt-6 space-y-4">
          <div className="flex items-center space-x-3">
            <WriteDiv />
            <p className="text-gray-800">
              <strong>Age:</strong> You must be over 25 years of age.
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <WriteDiv />
            <p className="text-gray-800">
              <strong>Nationality:</strong> You must be a Resident Citizen of
              India.
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <WriteDiv />
            <p className="text-gray-800">
              <strong>Educational Qualifications:</strong> No specific
              educational qualifications required.
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <WriteDiv />
            <p className="text-gray-800">
              <strong>Professional Qualifications:</strong> Open to
              professionals and business owners.
            </p>
          </div>
        </div>

        <h2 className="mt-8 text-2xl font-bold text-gray-900">
          Process Of Home Loan DSA Registration
        </h2>
        <p className="mt-4 text-gray-700">
          Registering to partner with Kota Holdings makes for a good start to a
          successful DSA career. This guide will walk you through each Online
          Loan DSA Registration step.
        </p>

        <div className="mt-6 space-y-6">
          {[
            {
              step: "1",
              title: "Apply",
              desc: "Click on 'Apply Now', fill in the details, and submit documents.",
            },
            {
              step: "2",
              title: "Expect a Call",
              desc: "Kota Holdings support team will call to guide and coordinate a meeting.",
            },
            {
              step: "3",
              title: "Meet",
              desc: "A Kota Holdings Manager will explain everything you need to know.",
            },
            {
              step: "4",
              title: "Sign DSA Agreement",
              desc: "Once signed, you'll become a Kota Holdings Partner and start earning.",
            },
          ].map((item, index) => (
            <div key={index} className="flex items-start space-x-4">
              <span className="text-white bg-[#FF6F00] font-bold w-8 h-8 flex items-center justify-center rounded-full">
                {item.step}
              </span>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  {item.title}
                </h3>
                <p className="text-gray-700">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <button className="mt-6 bg-[#FF6F00] text-white px-6 py-3 rounded-lg hover:bg-[#E65C00]">
          Apply Now
        </button>

        <h2 className="mt-8 text-2xl font-bold text-gray-900">
          Documents Required to Become a Home Loan DSA
        </h2>
        <ul className="mt-4 space-y-2 text-gray-700 list-disc list-inside">
          <li>Register with your mobile number.</li>
          <li>Soft copies of PAN card, Aadhaar, passport, or voter ID.</li>
          <li>Two passport-size photographs.</li>
          <li>GST registration (if applicable).</li>
          <li>Proof of employment or business address.</li>
          <li>Account details: Bank Account Cancelled Cheque.</li>
        </ul>

        <h2 className="mt-8 text-2xl font-bold text-gray-900">
          Why Partner With Kota Holdings? - Benefits And Perks
        </h2>
        <div className="mt-4 space-y-4">
          {[
            "Investment Free",
            "Instant Pay-outs",
            "High Potential Industry",
            "Guaranteed Success",
            "Channel Partner Recognition",
            "Easy Process",
          ].map((perk, index) => (
            <div key={index} className="flex items-center space-x-3">
              <span className="text-[#FF6F00] text-xl">✔</span>
              <p className="text-gray-800">{perk}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeLoan;
